import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { useCurrentBreakpoint } from "../../../../hooks/useCurrentBreakpoint";
import { useTranslations } from "../../../../providers/useTranslations";
import { FlavorFinderAnswer } from "../Answer/FlavorFinderAnswer";
import { FlavorFinderBackButton, FlavorFinderNextButton } from "../Buttons/FlavorFinderButtons";
import { FlavorFinderHeader } from "../Header/FlavorFinderHeader";
import { useFlavorFinderContext } from "../Provider/FlavorFinderContextProvider";
import "./FlavorFinderQuestion.scss";
export const FlavorFinderQuestion = ({ question, nextCtaLabel, backCtaLabel, questionNumberIndicator, selectionIndicator, totalNumberOfQuestions, hideNextButton = false, }) => {
    const { question: questionDetails, possibleAnswers = [] } = question;
    const { currentQuestionIndex, setCurrentQuestionIndex, setCurrentQuestion, questions, setCurrentView, setUserJourney, userJourney, setQuizResult, flavorFinderData, handlePreviousStepClick, } = useFlavorFinderContext();
    const { __ } = useTranslations();
    const counterLabel = `${questionNumberIndicator} ${currentQuestionIndex + 1}`;
    const { finalQuestion = null } = flavorFinderData;
    const { isSmall } = useCurrentBreakpoint();
    const selectedAnswerIdForCurrentQuestion = userJourney.find((step) => step.question?.question?.id === questionDetails?.id);
    const handleNextStepClick = useCallback(() => {
        const nextQuestion = questions.find((question) => question.onAnswerId === selectedAnswerIdForCurrentQuestion?.answer_id);
        setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
        if (nextQuestion) {
            handleQuestionOrResult(nextQuestion);
        }
    }, [
        finalQuestion,
        questions,
        selectedAnswerIdForCurrentQuestion?.answer_id,
        currentQuestionIndex,
        setCurrentQuestionIndex,
    ]);
    const handleQuestionOrResult = (nextQuestion) => {
        if (nextQuestion?.question) {
            setCurrentQuestion(nextQuestion);
            updateUserJourney("question", nextQuestion);
        }
        else if (nextQuestion?.results) {
            setQuizResults(nextQuestion);
            updateFinalStep();
        }
    };
    const updateUserJourney = (view, question) => {
        setUserJourney((prevJourney) => [...prevJourney, { view, question }]);
    };
    const setQuizResults = (nextQuestion) => {
        setQuizResult({
            resultsLink: nextQuestion?.resultsLink ?? "",
            results: nextQuestion.results ?? [],
            headerUrl: nextQuestion.headerUrl ?? "",
            resultsLinkWithDevice: nextQuestion.resultsLinkWithDevice ?? "",
        });
    };
    const updateFinalStep = () => {
        if (finalQuestion) {
            updateUserJourney("optional", finalQuestion);
            setCurrentView("optional");
        }
        else {
            updateUserJourney("consent");
            setCurrentView("consent");
        }
    };
    const handleAnswerClick = useCallback((answerId) => {
        const updatedJourney = [...userJourney];
        const currentStepIndex = updatedJourney.findIndex((step) => step.question?.question?.id === questionDetails?.id);
        const selectedAnswer = possibleAnswers.find((answer) => answer.id === answerId);
        if (currentStepIndex > -1) {
            updatedJourney[currentStepIndex].answer_id = answerId;
            updatedJourney[currentStepIndex].reference_name = selectedAnswer?.referenceName;
            updatedJourney[currentStepIndex].local_translation = selectedAnswer?.localTranslation;
        }
        else {
            updatedJourney.push({
                view: "question",
                question: question,
                answer_id: answerId,
                reference_name: selectedAnswer?.referenceName,
                local_translation: selectedAnswer?.localTranslation,
            });
        }
        setUserJourney(updatedJourney);
        if (hideNextButton) {
            handleNextStepClick();
        }
    }, [handleNextStepClick, hideNextButton, possibleAnswers, question, questionDetails?.id, setUserJourney, userJourney]);
    return (_jsxs("div", { className: "flavorfinder__questions-wrapper", "data-testid": "flavor-finder-question", children: [isSmall && _jsx(FlavorFinderBackButton, { onClick: handlePreviousStepClick, label: backCtaLabel }), _jsx("div", { className: "flavorfinder__question-container", children: _jsxs("div", { className: "flavorfinder__question", children: [_jsx(FlavorFinderHeader, { title: questionDetails?.title, subtitle: selectionIndicator, infoText: `${counterLabel} ${__("flavorfinder.numbers.separator")} ${totalNumberOfQuestions}`, children: !isSmall && _jsx(FlavorFinderBackButton, { onClick: handlePreviousStepClick, label: backCtaLabel }) }), _jsx("div", { className: `flavorfinder__answers flavorfinder__answers--count-${possibleAnswers?.length}`, children: possibleAnswers?.map((answer) => {
                                return (_jsx(FlavorFinderAnswer, { onAnswerClick: handleAnswerClick, answer: answer, isActive: answer.id === selectedAnswerIdForCurrentQuestion?.answer_id }, answer.id));
                            }) }), _jsx("div", { className: "flavorfinder__footer", children: _jsx(FlavorFinderNextButton, { onClick: handleNextStepClick, label: nextCtaLabel, disabled: selectedAnswerIdForCurrentQuestion?.answer_id === undefined, hidden: hideNextButton }) })] }) })] }));
};
//# sourceMappingURL=FlavorFinderQuestion.js.map